import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { checkPC } from '@/utils/utils'
import NewPC from "@/views/NewPC.vue";
import News from '@/views/News.vue'
import NewsDetail from "@/views/NewsDetail.vue";
import PlayerCenter from "@/views/PlayerCenter.vue";
import Information from "@/views/Information.vue";
import TopUp from "@/views/TopUp.vue";
import AliPayLink from "@/views/AliPayLink.vue";

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  {
    path: '/',
    name: 'NewHome',
    meta: {
      zoom: false
    },
    component: NewPC
  },
  {
    path: '/news',
    name: 'News',
    meta: {
      zoom: false
    },
    component: News
  },
  {
    path: '/news-detail',
    name: 'NewsDetail',
    meta: {
      zoom: false
    },
    component: NewsDetail
  },
  {
    path: '/player-center',
    name: 'PlayerCenter',
    meta: {
      zoom: false
    },
    component: PlayerCenter
  },
  {
    path: '/information',
    name: 'Information',
    meta: {
      zoom: false
    },
    component: Information
  },
  {
    path: '/top-up',
    name: 'TopUp',
    meta: {
      zoom: false
    },
    component: TopUp
  },
  {
    path: '/ali-pay-link',
    name: 'AliPayLink',
    meta: {
      zoom: false
    },
    component: AliPayLink
  },
  {
    path: '/m',
    name: 'home-m',
    meta: {
      zoom: true
    },
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/HomeView-M.vue')
    }
  },
  {
    path: '/ddf',
    name: 'ddf',
    meta:{
      title:'街球艺术',
      zoom: true
    },
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/DDF.vue')
    }
  },
  {
    path: '/ddf-testing',
    name: 'ddf-testing',
    meta:{
      title:'街球艺术',
      zoom: true
    },
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/DDF-T.vue')
    }
  },
  // {
  //   path: '/wx-transfer-t',
  //   name: 'wx-transfer-t',
  //   meta:{
  //     title:'街球艺术'
  //   },
  //   component: function () {
  //     return import(/* webpackChunkName: "about" */ '../views/WxTransfer-T.vue')
  //   }
  // },
  {
    path: '/ddf-result',
    name: 'ddf-result',
    meta:{
      title:'街球艺术',
      zoom: true
    },
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/DDF-Result.vue')
    }
  },
  {
    path: '/ddf-t-result',
    name: 'ddf-t-result',
    meta:{
      title:'街球艺术',
      zoom: true
    },
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/DDF-T-Result.vue')
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to,from,next)=>{
  // if (!util.checkDevice()){
  //     if ( to.name == 'device-error') {
  //         next()
  //     }
  //     next('/device-error')
  // }
  // else 

  // 如果路由配置中有 meta.title，则使用它作为页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = '街球艺术';
    
  }

  var device = checkPC()
  if (!device && to.name == 'home'){
      if ( to.name == 'home-m') {
          next()
      }
      next('/m')
  }
  else {
    next()
  }
  
})

export default router
